import React, { useState } from 'react';
import { Dimensions, Platform, ScrollView, View } from 'react-native'

import _ from 'lodash';
import PropTypes from 'prop-types';

import { Shimmer } from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { User_Types } from '@vfgroup-oneplatform/foundation/Utils/UserTypes.Enum';

import { PaymentMethodOptions } from './Components';
import PaymentBodyContainer from './Containers/PaymentBodyContainer';
import PaymentFooterContainer from './Containers/PaymentFooterContainer';
import usePayment from './Hooks/usePayment';
import usePaymentTracking from './Hooks/usePaymentTracking';
import {
  bodyWheelLoadingConfig,
  footerLoadingConfig,
  setupAutoBillBodyLoadingConfig,
  setupAutoBillFooterLoadingConfig,
  shimmerPlaceholderConfig,
  customTabBodyloadingConfig,
  footerButtonLoadingConfig,
} from './Loading';
import { PaymentTypes } from './Utils/PaymentTypes';

const Payment = props => {
  const {
    defaultWheelValue,
    onPressConfirmSelection,
    onPressAddExtraOffer,
    onPressSaveCard,
    toggleModal,
    type,
    defaultPayment,
    paymentCards,
    paymentOptions,
    setPaymentOptions,
    onSelectDefaultCard,
    offerValues,
    singleValue,
    value,
    setBillStatusToSettled,
    isLoading,
    theme,
    autoBillInitialDay,
    autoTopUpInitialData,
    loadingError,
    userType,
    accounts,
    getAdditionalTrackingInfo,
    customAmountMaximum,
    getTopUpData,
    isPaymentMethod,
    paymentMethodOptions,
    onPressConfirmVoucherCode,
    withCustomTab,
    isSelectRecipientPayGType,
    navigateToScreen,
    isCenter,
    toggleModal: _toggleModal,
  } = props;

  const [isPaymentMethodOptionsVisible, setIsPaymentMethodOptionsVisible] = useState(
    Array.isArray(paymentMethodOptions),
  );
  const [paymentType, setPaymentType] = useState(type);

  const isVoucherTopUp = paymentType === PaymentTypes.VOUCHER_TOP_UP;

  const hookProps = {
    defaultWheelValue,
    onPressConfirmSelection,
    onPressAddExtraOffer,
    onPressSaveCard,
    defaultPayment,
    toggleModal,
    type: paymentType,
    setPaymentOptions,
    onSelectDefaultCard,
    paymentOptions,
    offerValues,
    singleValue,
    value,
    setBillStatusToSettled,
    autoBillInitialDay,
    autoTopUpInitialData,
    loadingError,
    userType,
    accounts,
    customAmountMaximum,
    getTopUpData,
    onPressConfirmVoucherCode,
    isSelectRecipientPayGType,
  };

  const {
    status,
    selectedValue,
    handleSelectDefaultCard,
    onSaveNewCard,
    onOpenCardList,
    onAddCard,
    checkObjectHasProperty,
    onDiscardGift,
    onBuyOffer,
    onSelectWheelValue,
    onUpgradePayment,
    onRejectUpgradePayment,
    onClosePayment,
    onCompletePurchaseOfferPress,
    onConfirmPayment,
    newBalance,
    newExtraOffer,
    error,
    onSelectBillDay,
    onSelectAutoTopUpData,
    autoBillDay,
    autoTopUpData,
    autoBillMonth,
    autoTopUpSuccessPlaceholders,
    onSaveTopUpSomeOneCard,
    setIsValidTopupNumber,
    isValidTopupNumber,
    onContactListIconPress,
    phoneNo,
    setPhoneNo,
    onTopUpRecipientNumberSubmit,
    onAutoTopUpNext,
    onAddOffer,
    onBackFromOffer,
    onAutoTopUpErrorReturn,
    selectedTab,
    onSelectTabChange,
    customAmountValidation,
    customAmount,
    onChangeCustomAmount,
    setIsValidVoucherTopupNumber,
    isValidVoucherTopupNumber,
    shouldScanVoucherCode,
    onCameraPressed,
    onQRRead,
    onCancelVoucherQRScanner,
    voucherTopupNumber,
    setVoucherTopupNumber,
    onCodeConfirm,
    voucherAmount,
    isTwoBtnVoucherError,
    onRetryAgainPress,
    goBackView,
  } = usePayment(hookProps);

  usePaymentTracking({
    getAdditionalTrackingInfo,
    status,
    type: paymentType,
    selectedValue,
    value,
    paymentOptions,
  });

  const renderBodyLoading = () => {
    if (isLoading && !paymentOptions.screen && !isVoucherTopUp) {
      const isAutoBillType =
        paymentType === PaymentTypes.SETUP_AUTO_BILL || paymentType === PaymentTypes.EDIT_AUTO_BILL;
      const withCustomTabAmount = paymentOptions.withCustomTabAmount;
      return (
        <Shimmer
          config={
            isAutoBillType
              ? setupAutoBillBodyLoadingConfig
              : withCustomTabAmount
                ? customTabBodyloadingConfig
                : bodyWheelLoadingConfig
          }
          shimmerPlaceholderConfig={shimmerPlaceholderConfig}
        />
      );
    }
    return (
      <>
        <PaymentBodyContainer
          {...props}
          type={paymentType}
          onAddOffer={onAddOffer}
          checkObjectHasProperty={checkObjectHasProperty}
          onSelectWheelValue={onSelectWheelValue}
          selectedValue={selectedValue}
          onPressSaveCard={onSaveNewCard}
          onSelectDefaultCard={handleSelectDefaultCard}
          screen={paymentOptions.screen || status}
          newBalance={newBalance}
          newExtraOffer={newExtraOffer}
          isAddDataWithGift={paymentOptions.isAddDataWithGift}
          onSelectBillDay={onSelectBillDay}
          onSelectAutoTopUpData={onSelectAutoTopUpData}
          autoBillDay={autoBillDay}
          autoTopUpData={autoTopUpData}
          autoBillMonth={autoBillMonth}
          autoTopUpSuccessPlaceholders={autoTopUpSuccessPlaceholders}
          error={error}
          handleOnPressRecipient={onSaveTopUpSomeOneCard}
          setIsValidTopupNumber={setIsValidTopupNumber}
          onContactListIconPress={onContactListIconPress}
          phoneNo={phoneNo}
          setPhoneNo={setPhoneNo}
          userType={userType}
          selectedTab={selectedTab}
          onSelectTabChange={onSelectTabChange}
          customAmount={customAmount}
          onChangeCustomAmount={onChangeCustomAmount}
          withCustomTabAmount={paymentOptions.withCustomTabAmount && withCustomTab}
          customAmountValidation={customAmountValidation}
          customAmountMaximum={customAmountMaximum}
          setIsValidVoucherTopupNumber={setIsValidVoucherTopupNumber}
          isValidVoucherTopupNumber={isValidVoucherTopupNumber}
          shouldScanVoucherCode={shouldScanVoucherCode}
          onCameraPressed={onCameraPressed}
          onQRRead={onQRRead}
          voucherTopupNumber={voucherTopupNumber}
          setVoucherTopupNumber={setVoucherTopupNumber}
          voucherAmount={voucherAmount}
          isValidTopupNumber={isValidTopupNumber}
          navigateToScreen={navigateToScreen}
          goBackView={goBackView}
          isCenter={isCenter}
          _toggleModal={_toggleModal}
        />
      </>
    );
  };

  const renderFooterLoading = () => {
    if (isLoading && !paymentOptions.screen && !isVoucherTopUp) {
      const isAutoBillType =
        paymentType === PaymentTypes.SETUP_AUTO_BILL || paymentType === PaymentTypes.EDIT_AUTO_BILL;
      return (
        <Shimmer
          config={
            isAutoBillType
              ? setupAutoBillFooterLoadingConfig(theme)
              : isPaymentMethod
                ? footerLoadingConfig(theme)
                : footerButtonLoadingConfig(theme)
          }
          shimmerPlaceholderConfig={shimmerPlaceholderConfig}
        />
      );
    }
    return (
      <PaymentFooterContainer
        {...props}
        type={paymentType}
        isPaymentMethod={isPaymentMethod}
        checkObjectHasProperty={checkObjectHasProperty}
        onConfirmPayment={onConfirmPayment}
        onPressPaymentCancel={onClosePayment}
        onDiscardGift={onDiscardGift}
        onCompletePurchaseOfferPress={onCompletePurchaseOfferPress}
        onClosePayment={onClosePayment}
        onUpgradePayment={onUpgradePayment}
        onRejectUpgradePayment={onRejectUpgradePayment}
        onBuyOffer={onBuyOffer}
        selectedValue={selectedValue}
        defaultPayment={defaultPayment}
        paymentCards={paymentCards}
        onAddCard={onAddCard}
        onOpenCardList={onOpenCardList}
        isCardListOpend={paymentOptions.isCardListOpend}
        onSelectDefaultCard={handleSelectDefaultCard}
        screen={paymentOptions.screen || status}
        isValidTopupNumber={isValidTopupNumber}
        onTopUpRecipientNumberSubmit={onTopUpRecipientNumberSubmit}
        onAutoTopUpNext={onAutoTopUpNext}
        onAutoTopUpErrorReturn={onAutoTopUpErrorReturn}
        autoTopUpData={autoTopUpData}
        onBackFromOffer={onBackFromOffer}
        customAmountValidation={customAmountValidation}
        onCancelQRCodeScan={onCancelVoucherQRScanner}
        isValidVoucherTopupNumber={isValidVoucherTopupNumber}
        onConfirmCode={onCodeConfirm}
        isTwoBtnVoucherError={isTwoBtnVoucherError}
        onRetryAgainPress={onRetryAgainPress}
      />
    );
  };

  const onPaymentMethodOptionPress = (_paymentType, _onPress) => {
    setPaymentType(_paymentType);
    setIsPaymentMethodOptionsVisible(false);

    _.isFunction(_onPress) && _onPress();
  };

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <ScrollView contentContainerStyle={{ padding: isCenter ? 20 : 0, paddingVertical: isCenter ? 20 : 64, paddingBottom: !isCenter && '15%' }}>
        {renderBodyLoading()}
        {renderFooterLoading()}
      </ScrollView>
    )
  }

  return isPaymentMethodOptionsVisible ? (
    <PaymentMethodOptions
      paymentMethodOptions={paymentMethodOptions}
      theme={theme}
      onItemPress={onPaymentMethodOptionPress}
    />
  ) : (
    <>
      {renderBodyLoading()}
      {renderFooterLoading()}
    </>
  );
};

Payment.defaultProps = {
  toggleModal: () => { },
  onPressSaveCard: () => Promise.resolve(true),
  defaultPayment: {},
  paymentOptions: {},
  getAdditionalTrackingInfo: () => { },
  theme: LightThemeColors,
};

Payment.propTypes = {
  isPaymentMethod: PropTypes.bool,
  isLoading: PropTypes.bool,
  defaultPayment: PropTypes.object,
  toggleModal: PropTypes.func,
  currency: PropTypes.string,
  onPressAddExtraOffer: PropTypes.func,
  onPressSaveCard: PropTypes.func,
  onPressConfirmSelection: PropTypes.func,
  wheelValues: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      gift: PropTypes.bool,
    }),
  ),
  offerValues: PropTypes.shape({
    giftUnit: PropTypes.string,
    giftValue: PropTypes.number,
    giftNormalPrice: PropTypes.number,
    giftOfferPrice: PropTypes.number,
    currency: PropTypes.string,
  }),
  defaultWheelValue: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      gift: PropTypes.bool,
    }),
  ),
  wheelSelectorCurrencyAccessibilityLabel: PropTypes.string,
  wheelSelectorGiftIconAccessibilityLabel: PropTypes.string,
  wheelSelectorValueAccessibilityLabel: PropTypes.string,
  offerMainTitleAccessibilityLabel: PropTypes.string,
  offerEndDateAccessibilityLabel: PropTypes.string,
  paymentBodyMainIconAccessibilityLabel: PropTypes.string,
  paymentBodyMainTitleAccessibilityLabel: PropTypes.string,
  paymentBodySecondaryTitleAccessibilityLabel: PropTypes.string,
  paymentMethodAccessibilityLabel: PropTypes.string,
  paymentVisaInfoAccessibilityLabel: PropTypes.string,
  acceptOfferBtnAccessibilityLabel: PropTypes.string,
  refuseOfferBtnAccessibilityLabel: PropTypes.string,
  confirmPaymentBtnAccessibilityLabel: PropTypes.string,
  cancelPaymentBtnAccessibilityLabel: PropTypes.string,
  acceptGiftBtnAccessibilityLabel: PropTypes.string,
  refuseGiftBtnAccessibilityLabel: PropTypes.string,
  closetBtnAccessibilityLabel: PropTypes.string,
  type: PropTypes.oneOf(Object.values(PaymentTypes)),
  paymentCards: PropTypes.array,
  paymentOptions: PropTypes.object,
  setPaymentOptions: PropTypes.func,
  onSelectDefaultCard: PropTypes.func,
  singleValue: PropTypes.bool,
  value: PropTypes.object,
  closeModal: PropTypes.func,
  setBillStatusToSettled: PropTypes.func,
  onTopUpSomeOneOpen: PropTypes.func,
  onTopUpSomeOneCardPress: PropTypes.func,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  autoBillInitialDay: PropTypes.number,
  autoTopUpInitialData: PropTypes.shape({
    occurrence: PropTypes.oneOf(['weekly', 'monthly', 'amount']),
    selectedIndex: PropTypes.number,
    selectedValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  loadingError: PropTypes.bool,
  successBtnID: PropTypes.string,
  userType: PropTypes.oneOf(Object.values(User_Types)),
  accounts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      type: PropTypes.string,
      image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      phone: PropTypes.string,
    }),
  ),
  getAdditionalTrackingInfo: PropTypes.func,
  customAmountMaximum: PropTypes.number.isRequired,
  getTopUpData: PropTypes.func.isRequired,
  paymentMethodOptions: PropTypes.array,
  onPressConfirmVoucherCode: PropTypes.func,
  withCustomTab: PropTypes.bool,
  isSelectRecipientPayGType: PropTypes.bool,
};

export default Payment;
